import { authService } from "@/features/auth/services/authService";
import { getCmsUrl, getTicketingAppUrl } from "@/lib/app-config";

function appendRedirectTo(baseUrl: string, redirectTo?: string): string {
  if (!redirectTo) return baseUrl;
  const separator = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${separator}redirectTo=${encodeURIComponent(redirectTo)}`;
}

function resolveCmsHandoffUrl(cmsLoginUrl: string): string {
  if (cmsLoginUrl.startsWith("http")) return cmsLoginUrl;
  const cmsBase = getCmsUrl();
  return `${cmsBase}${cmsLoginUrl.startsWith("/") ? cmsLoginUrl : `/${cmsLoginUrl}`}`;
}

function resolveTicketingHandoffUrl(ticketingLoginUrl: string): string {
  if (ticketingLoginUrl.startsWith("http")) return ticketingLoginUrl;
  const ticketingBase = getTicketingAppUrl();
  return `${ticketingBase}${ticketingLoginUrl.startsWith("/") ? ticketingLoginUrl : `/${ticketingLoginUrl}`}`;
}

/** Open Strapi CMS with a one-time SSO handoff from the current dashboard session. */
export async function openCmsHandoff(
  redirectTo?: string,
  fallbackHref?: string,
): Promise<void> {
  try {
    const { cmsLoginUrl } = await authService.issueCmsHandoff();
    const handoffBase = resolveCmsHandoffUrl(cmsLoginUrl);
    const target = appendRedirectTo(handoffBase, redirectTo);
    window.open(target, "_blank", "noopener,noreferrer");
  } catch {
    if (fallbackHref) {
      window.open(fallbackHref, "_blank", "noopener,noreferrer");
    }
  }
}

/** Open mof-ticketing with a one-time SSO handoff from the current dashboard session. */
export async function openTicketingHandoff(redirectTo?: string): Promise<void> {
  try {
    const { ticketingLoginUrl } = await authService.issueTicketingHandoff();
    const handoffBase = resolveTicketingHandoffUrl(ticketingLoginUrl);
    const target = appendRedirectTo(handoffBase, redirectTo);
    window.open(target, "_blank", "noopener,noreferrer");
  } catch {
    const fallback = `${getTicketingAppUrl()}${redirectTo ?? "/"}`;
    window.open(fallback, "_blank", "noopener,noreferrer");
  }
}
